import {ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {
  BalanceItem, BokkzJrLogic,
  ClientEntity, FormattedExplanation, Jaarrapportage,
  JaarrapportageEntity, Jaarrekening, TrialBalanceItem
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil} from 'rxjs';
import {SpecTrialbalanceComponent} from '../spec-trialbalance/spec-trialbalance.component';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SpecFormattedexplanationComponent} from '../spec-formattedexplanation/spec-formattedexplanation.component';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-vorderingen',
  templateUrl: './spec-vorderingen.component.html',
  imports: [
    SpecTrialbalanceComponent,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-vorderingen.component.scss']
})
export class SpecVorderingenComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public receivablesFg = {} as FormGroup;
  public tradeReceivablesFg = {} as FormGroup;
  public receivablesGroupCompaniesCurrentFg = {} as FormGroup;
  public receivablesOtherAffiliatedCompaniesCurrentFg = {} as FormGroup;
  public receivablesShareholdersParticipatingInterestsCurrentFg = {} as FormGroup;
  public calledUpShareCapitalFg = {} as FormGroup;
  public pensionReceivablesReceivablesOtherCurrentFg = {} as FormGroup;
  public receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrentFg = {} as FormGroup;
  public loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrentFg = {} as FormGroup;
  public loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrentFg = {} as FormGroup;
  public otherReceivablesOtherCurrentFg = {} as FormGroup;
  public receivablesOtherCurrentFg = {} as FormGroup;
  public taxReceivablesFg = {} as FormGroup;
  public receivablesIncomeTaxFg = {} as FormGroup;
  public deferredTaxAssetsCurrentFg = {} as FormGroup;
  public pensionReceivablesReceivablesAccruedIncomeFg = {} as FormGroup;
  public accruedIncomeOtherFg = {} as FormGroup;
  public accruedIncomeFg = {} as FormGroup;

  public receivablesDisclosureFg = {} as FormGroup;
  public tradeReceivablesDisclosureFg = {} as FormGroup;
  public receivablesGroupCompaniesCurrentDisclosureFg = {} as FormGroup;
  public receivablesOtherAffiliatedCompaniesCurrentDisclosureFg = {} as FormGroup;
  public receivablesShareholdersParticipatingInterestsCurrentDisclosureFg = {} as FormGroup;
  public pensionReceivablesDisclosureFg = {} as FormGroup;
  public taxReceivablesDisclosureFg = {} as FormGroup;
  public receivablesIncomeTaxDisclosureFg = {} as FormGroup;
  public deferredTaxAssetsCurrentDisclosureFg = {} as FormGroup;
  public accruedIncomeDisclosureFg = {} as FormGroup;
  public receivablesMaturityExceedingOneYearDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.receivablesFg = this.jrDataService.createFormGroupBalanceItem();
    this.tradeReceivablesFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesGroupCompaniesCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesOtherAffiliatedCompaniesCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesShareholdersParticipatingInterestsCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.calledUpShareCapitalFg = this.jrDataService.createFormGroupBalanceItem();
    this.pensionReceivablesReceivablesOtherCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.otherReceivablesOtherCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesOtherCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.taxReceivablesFg = this.jrDataService.createFormGroupBalanceItem();
    this.receivablesIncomeTaxFg = this.jrDataService.createFormGroupBalanceItem();
    this.deferredTaxAssetsCurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.pensionReceivablesReceivablesAccruedIncomeFg = this.jrDataService.createFormGroupBalanceItem();
    this.accruedIncomeOtherFg = this.jrDataService.createFormGroupBalanceItem();
    this.accruedIncomeFg = this.jrDataService.createFormGroupBalanceItem();

    this.receivablesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.tradeReceivablesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesGroupCompaniesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesOtherAffiliatedCompaniesCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesShareholdersParticipatingInterestsCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.pensionReceivablesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.taxReceivablesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesIncomeTaxDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.deferredTaxAssetsCurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.accruedIncomeDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.receivablesMaturityExceedingOneYearDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const vorderingen = value.rapportage?.jaarrekeningen?.at(0)?.balans?.vorderingen;

    if (vorderingen) {
      this.receivablesFg.reset()
      this.receivablesOtherCurrentFg.reset()
      this.accruedIncomeFg.reset()


      if (vorderingen.receivables) {
        this.receivablesFg.patchValue(vorderingen.receivables, {emitEvent: false})
      }

      const uitsplitsing = vorderingen.vorderingenUitsplitsing;
      const tekstueel = vorderingen.vorderingenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.tradeReceivables) {
          const subItem = uitsplitsing.tradeReceivables;
          this.tradeReceivablesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.tradeReceivablesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesGroupCompaniesCurrent) {
          const subItem = uitsplitsing.receivablesGroupCompaniesCurrent;
          this.receivablesGroupCompaniesCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesGroupCompaniesCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesOtherAffiliatedCompaniesCurrent) {
          const subItem = uitsplitsing.receivablesOtherAffiliatedCompaniesCurrent;
          this.receivablesOtherAffiliatedCompaniesCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesOtherAffiliatedCompaniesCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesShareholdersParticipatingInterestsCurrent) {
          const subItem = uitsplitsing.receivablesShareholdersParticipatingInterestsCurrent;
          this.receivablesShareholdersParticipatingInterestsCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesShareholdersParticipatingInterestsCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.calledUpShareCapital) {
          const subItem = uitsplitsing.calledUpShareCapital;
          this.calledUpShareCapitalFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.calledUpShareCapitalFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.pensionReceivablesReceivablesOtherCurrent) {
          const subItem = uitsplitsing.pensionReceivablesReceivablesOtherCurrent;
          this.pensionReceivablesReceivablesOtherCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.pensionReceivablesReceivablesOtherCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrent) {
          const subItem = uitsplitsing.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrent;
          this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrent) {
          const subItem = uitsplitsing.loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrent;
          this.loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrent) {
          const subItem = uitsplitsing.loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrent;
          this.loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.otherReceivablesOtherCurrent) {
          const subItem = uitsplitsing.otherReceivablesOtherCurrent;
          this.otherReceivablesOtherCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.otherReceivablesOtherCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesOtherCurrent) {
          this.receivablesOtherCurrentFg.patchValue(uitsplitsing.receivablesOtherCurrent, {emitEvent: false})
        }
        if (uitsplitsing?.taxReceivables) {
          const subItem = uitsplitsing.taxReceivables;
          this.taxReceivablesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.taxReceivablesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.receivablesIncomeTax) {
          const subItem = uitsplitsing.receivablesIncomeTax;
          this.receivablesIncomeTaxFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.receivablesIncomeTaxFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.deferredTaxAssetsCurrent) {
          const subItem = uitsplitsing.deferredTaxAssetsCurrent;
          this.deferredTaxAssetsCurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.deferredTaxAssetsCurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.pensionReceivablesReceivablesAccruedIncome) {
          const subItem = uitsplitsing.pensionReceivablesReceivablesAccruedIncome;
          this.pensionReceivablesReceivablesAccruedIncomeFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.pensionReceivablesReceivablesAccruedIncomeFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.accruedIncomeOther) {
          const subItem = uitsplitsing.accruedIncomeOther;
          this.accruedIncomeOtherFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.accruedIncomeOtherFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.accruedIncome) {
          this.accruedIncomeFg.patchValue(uitsplitsing.accruedIncome, {emitEvent: false})
        }
      }
      if (tekstueel) {
        if (tekstueel.receivablesDisclosure) {
          this.receivablesDisclosureFg.patchValue(tekstueel.receivablesDisclosure);
        }
        if (tekstueel.tradeReceivablesDisclosure) {
          this.tradeReceivablesDisclosureFg.patchValue(tekstueel.tradeReceivablesDisclosure);
        }
        if (tekstueel.receivablesGroupCompaniesCurrentDisclosure) {
          this.receivablesGroupCompaniesCurrentDisclosureFg.patchValue(tekstueel.receivablesGroupCompaniesCurrentDisclosure);
        }
        if (tekstueel.receivablesOtherAffiliatedCompaniesCurrentDisclosure) {
          this.receivablesOtherAffiliatedCompaniesCurrentDisclosureFg.patchValue(tekstueel.receivablesOtherAffiliatedCompaniesCurrentDisclosure);
        }
        if (tekstueel.receivablesShareholdersParticipatingInterestsCurrentDisclosure) {
          this.receivablesShareholdersParticipatingInterestsCurrentDisclosureFg.patchValue(tekstueel.receivablesShareholdersParticipatingInterestsCurrentDisclosure);
        }
        if (tekstueel.pensionReceivablesDisclosure) {
          this.pensionReceivablesDisclosureFg.patchValue(tekstueel.pensionReceivablesDisclosure);
        }
        if (tekstueel.taxReceivablesDisclosure) {
          this.taxReceivablesDisclosureFg.patchValue(tekstueel.taxReceivablesDisclosure);
        }
        if (tekstueel.receivablesIncomeTaxDisclosure) {
          this.receivablesIncomeTaxDisclosureFg.patchValue(tekstueel.receivablesIncomeTaxDisclosure);
        }
        if (tekstueel.deferredTaxAssetsCurrentDisclosure) {
          this.deferredTaxAssetsCurrentDisclosureFg.patchValue(tekstueel.deferredTaxAssetsCurrentDisclosure);
        }
        if (tekstueel.accruedIncomeDisclosure) {
          this.accruedIncomeDisclosureFg.patchValue(tekstueel.accruedIncomeDisclosure);
        }
        if (tekstueel.receivablesMaturityExceedingOneYearDisclosure) {
          this.receivablesMaturityExceedingOneYearDisclosureFg.patchValue(tekstueel.receivablesMaturityExceedingOneYearDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.tradeReceivablesFg.updateValueAndValidity();
    this.receivablesGroupCompaniesCurrentFg.updateValueAndValidity();
    this.receivablesOtherAffiliatedCompaniesCurrentFg.updateValueAndValidity();
    this.receivablesShareholdersParticipatingInterestsCurrentFg.updateValueAndValidity();
    this.calledUpShareCapitalFg.updateValueAndValidity();
    this.pensionReceivablesReceivablesOtherCurrentFg.updateValueAndValidity();
    this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrentFg.updateValueAndValidity();
    this.loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrentFg.updateValueAndValidity();
    this.loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrentFg.updateValueAndValidity();
    this.otherReceivablesOtherCurrentFg.updateValueAndValidity();
    this.receivablesOtherCurrentFg.updateValueAndValidity();
    this.taxReceivablesFg.updateValueAndValidity();
    this.receivablesIncomeTaxFg.updateValueAndValidity();
    this.deferredTaxAssetsCurrentFg.updateValueAndValidity();
    this.pensionReceivablesReceivablesAccruedIncomeFg.updateValueAndValidity();
    this.accruedIncomeOtherFg.updateValueAndValidity();
    this.accruedIncomeFg.updateValueAndValidity();

    this.receivablesDisclosureFg.updateValueAndValidity();
    this.tradeReceivablesDisclosureFg.updateValueAndValidity();
    this.receivablesGroupCompaniesCurrentDisclosureFg.updateValueAndValidity();
    this.receivablesOtherAffiliatedCompaniesCurrentDisclosureFg.updateValueAndValidity();
    this.receivablesShareholdersParticipatingInterestsCurrentDisclosureFg.updateValueAndValidity();
    this.pensionReceivablesDisclosureFg.updateValueAndValidity();
    this.taxReceivablesDisclosureFg.updateValueAndValidity();
    this.receivablesIncomeTaxDisclosureFg.updateValueAndValidity();
    this.deferredTaxAssetsCurrentDisclosureFg.updateValueAndValidity();
    this.accruedIncomeDisclosureFg.updateValueAndValidity();
    this.receivablesMaturityExceedingOneYearDisclosureFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].balans,
          vorderingen: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.vorderingen,
            vorderingenUitsplitsing: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.vorderingen?.vorderingenUitsplitsing,
              tradeReceivables: this.tradeReceivablesFg.value,
              receivablesGroupCompaniesCurrent: this.receivablesGroupCompaniesCurrentFg.value,
              receivablesOtherAffiliatedCompaniesCurrent: this.receivablesOtherAffiliatedCompaniesCurrentFg.value,
              receivablesShareholdersParticipatingInterestsCurrent: this.receivablesShareholdersParticipatingInterestsCurrentFg.value,
              calledUpShareCapital: this.calledUpShareCapitalFg.value,
              pensionReceivablesReceivablesOtherCurrent: this.pensionReceivablesReceivablesOtherCurrentFg.value,
              receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrent: this.receivablesFromLoansAndAdvancesToParticipantsOrRegisteredShareholdersCurrentFg.value,
              loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrent: this.loansAdvancesGuaranteesOnBehalfOfManagingDirectorsFormerManagingDirectorsCurrentFg.value,
              loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrent: this.loansAdvancesGuaranteesOnBehalfOfSupervisoryDirectorsFormerSupervisoryDirectorsCurrentFg.value,
              otherReceivablesOtherCurrent: this.otherReceivablesOtherCurrentFg.value,
              taxReceivables: this.taxReceivablesFg.value,
              receivablesIncomeTax: this.receivablesIncomeTaxFg.value,
              deferredTaxAssetsCurrent: this.deferredTaxAssetsCurrentFg.value,
              pensionReceivablesReceivablesAccruedIncome: this.pensionReceivablesReceivablesAccruedIncomeFg.value,
              accruedIncomeOther: this.accruedIncomeOtherFg.value,
            },
            vorderingenTekstueel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.vorderingen?.vorderingenTekstueel,
              receivablesDisclosure: this.receivablesDisclosureFg.value,
              tradeReceivablesDisclosure: this.tradeReceivablesDisclosureFg.value,
              receivablesGroupCompaniesCurrentDisclosure: this.receivablesGroupCompaniesCurrentDisclosureFg.value,
              receivablesOtherAffiliatedCompaniesCurrentDisclosure: this.receivablesOtherAffiliatedCompaniesCurrentDisclosureFg.value,
              receivablesShareholdersParticipatingInterestsCurrentDisclosure: this.receivablesShareholdersParticipatingInterestsCurrentDisclosureFg.value,
              pensionReceivablesDisclosure: this.pensionReceivablesDisclosureFg.value,
              taxReceivablesDisclosure: this.taxReceivablesDisclosureFg.value,
              receivablesIncomeTaxDisclosure: this.receivablesIncomeTaxDisclosureFg.value,
              deferredTaxAssetsCurrentDisclosure: this.deferredTaxAssetsCurrentDisclosureFg.value,
              accruedIncomeDisclosure: this.accruedIncomeDisclosureFg.value,
              receivablesMaturityExceedingOneYearDisclosure: this.receivablesMaturityExceedingOneYearDisclosureFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }

}
